export const qaDomain = "";
export const iconPath = "/recursos/icons";

// routes: MenuWrapper
export const BILLING_ROUTE = "/facturacion";
export const ACCOUNT_ROUTE = "/mi-cuenta";
export const TEAM_ROUTE = "/empleados";
export const PRODUCTS_ROUTE = "/almacen";
export const LOUNGES_ROUTE = "/locales";
export const SUPPLIERS_ROUTE = "/proveedores";
export const ACCOUNTS_PAYABLE_ROUTE = "/cuentas-por-pagar";
export const RECEIVABLES_ROUTE = "/cuentas-por-cobrar";
export const EXCHANGE_RATE_ROUTE = "/tipo-cambio";
export const PURCHASE_ORDERS_ROUTE = "/ordenes-compra";
export const REPORTS_ROUTE = "/reportes";
export const BOOKING_ROUTE = "/reservas";
export const TAXES_ROUTE = "/impuestos";
export const SERVICES_ROUTE = "/servicios";
export const CASH_REGISTER = "/cajas";
export const CLIENTS_ROUTE = "/clientes";
export const STATISTICS_ROUTE = "/estadisticas";
export const SECURITY_ROUTE = "/roles";
export const MARKETING_ROUTE = "/marketing";
export const COMMISSIONS_ROUTE = "/comisiones";
export const ANALYTICS_ROUTE = "/analitica";
export const COMANDAS_ROUTE = "/comandas";
export const INTERNAL_ORDERS_ROUTE = "/pedidos-internos";
export const COMANDA_TABLET_ROUTE = "/comanda-tablet";
export const MI_PERFIL_ROUTE = "/mi-perfil";
export const CERTIFICATE_ROUTE = "/certificate";
export const HELP_CENTER_ROUTE = "/ayuda";
export const INTEGRATIONS_ROUTE = "/integraciones";
export const LOYALTY_ROUTE = "/fidelizacion";
